import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import {
  Col,
  Label,
  Row,
} from "reactstrap";
import { LIST_OPTION_DURATION_WORK, LIST_OPTION_SALARY_TYPE } from "helpers/constans";
import DropdownHours from "components/Common/DropdownHours";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import { NumericFormat } from 'react-number-format';
 
export interface Props {
  formik: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const CON_WORKING_DAYS =  [
  {
    label: "Specify days",
    value: false
  },
  {
    label: "Negotiation",
    value: true
  }
]

const CON_WORKING_TIME =  [
  {
    label: "Specify time",
    value: false
  },
  {
    label: "Negotiation",
    value: true
  }
]

const CON_WORKING_SALARY =  [
  {
    label: "Specify amount",
    value: false
  },
  {
    label: "Negotiation",
    value: true
  }
]

const CON_WORKING_DAY_OF_WEEK = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

const WorkingConditions = ({ formik }: Props) => {
  const { t } = useTranslation();

  const toggleDay = (day: any) => {
    formik.setFieldValue('workDays', {
      ...formik.values.workDays,
      [day]: !formik.values.workDays[day],
    });
  };

  function isOvernight() {
    const startTime = formik?.values?.workTimeRange?.startTime;
    const endTime = formik?.values?.workTimeRange?.endTime;
    if(startTime || endTime) {
      const [startHour, startMinute] = startTime ? startTime?.split(":")?.map(Number) : "";
      const [endHour, endMinute] = endTime ? endTime?.split(":")?.map(Number) : "";
    
      if(startHour > endHour) {
        return true;
      }else if(startHour == endHour && startMinute > endMinute) {
        return true;
      }
      return false;
    }

    return false;
  }

  return (
    <React.Fragment>
      <div
            className="d-flex flex-column mb-4 pt-3 pb-1 px-3 position-relative"
            style={{
              border: "1px dashed var(--vz-primary)",
              borderRadius: "4px",
            }}
          >
            <span
              className="text-primary position-absolute fs-13 px-1"
              style={{
                backgroundColor: "var(--vz-secondary-bg)",
                top: "0px",
                transform: "translateY(-50%)",
              }}
            >
              {t("Working Conditions")}
            </span>
            <Row>
              <Col lg={12}>
                <div className="mb-3">
                  <Label htmlFor="titleKoreaInput" className="form-label">
                    {t("Working days")}{" "}
                    <span className="text-danger">*</span>
                  </Label>

                  <div className="d-flex justify-content-start align-items-center">
                    {CON_WORKING_DAYS?.map((item, index) => {
                      return (
                        <div
                          className="d-flex justify-content-start align-items-center form-check me-3"
                          key={index}
                          onClick={() => {
                            formik?.setFieldValue("durationFlexible", item.value)
                          }}
                        >
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name="working_days"
                            id={`working_days-${String(item?.value)}`}
                            // value={item?.value}
                            checked={item?.value === formik?.values?.durationFlexible}
                            style={{ minWidth: "16px" }}
                            onChange={(event) => {
                              formik?.setFieldValue("durationFlexible", item.value)
                            }}
                          />
                          <label
                            className="form-check-label position-relative"
                            htmlFor={`working_days-${String(item?.value)}`}
                          >
                            {t(item?.label)}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Col>

              {
                formik?.values?.durationFlexible === false && (
                  <Col lg={12}>
                    <div className="d-flex gap-2 mb-3">
                      {CON_WORKING_DAY_OF_WEEK.map((day) => (
                        <button
                          key={day}
                          type="button" // Ensure button doesn't trigger form submission
                          onClick={() => toggleDay(day)}
                          style={{ border: 'unset' }}
                          className={`px-4 py-2 rounded-md ${
                            formik.values.workDays[day] ? 'bg-primary text-white' : 'text-gray-300'
                          }`}
                        >
                          {t(day)}
                        </button>
                      ))}
                    </div>
                  </Col>
                )
              }

              <Col lg={12}>
                <div className="mb-3">
                  <Label htmlFor="titleKoreaInput" className="form-label">
                    {t("Working Time")}{" "}
                    <span className="text-danger">*</span>
                  </Label>

                  <div className="d-flex justify-content-start align-items-center">
                    {CON_WORKING_TIME?.map((item, index) => {
                      return (
                        <div
                          className="d-flex justify-content-start align-items-center form-check me-3"
                          key={index}
                          onClick={() => {
                            formik?.setFieldValue("workTimeFlexible", item.value)
                          }}
                        >
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name="working_time"
                            id={`working_time-${String(item?.value)}`}
                            // value={item?.value}
                            checked={item?.value === formik?.values?.workTimeFlexible}
                            style={{ minWidth: "16px" }}
                            onChange={(event) => {
                              formik?.setFieldValue("workTimeFlexible", item.value)
                            }}
                          />
                          <label
                            className="form-check-label position-relative"
                            htmlFor={`working_time-${String(item?.value)}`}
                          >
                            {t(item?.label)}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Col>

              {
                formik?.values?.workTimeFlexible === false && (
                  <Col
                    lg={12}
                    className="date-picker-wrapper-custom"
                  >
                    <Row className="mb-3 d-flex align-items-center">
                      <Col lg={3} style={{maxWidth: "160px"}}>
                        <DropdownHours
                          name="startTime"
                          initialValue={formik?.values?.workTimeRange?.startTime || ''}
                          onChangeSelect={(value: any) => {
                            formik.setFieldValue(
                              `workTimeRange.startTime`,
                              value?.value
                            );
                          }}
                        />
                      </Col>
                      <Col lg={1} style={{paddingLeft: "0", paddingRight: "0", textAlign: "center", maxWidth: "2px"}}>
                          <span>~</span>
                      </Col>
                      <Col lg={3} style={{maxWidth: "160px"}}>
                        <DropdownHours
                          name="endTime"
                          initialValue={formik?.values?.workTimeRange?.endTime}
                          onChangeSelect={(value: any) => {
                            formik.setFieldValue(
                              `workTimeRange.endTime`,
                              value?.value
                            );
                          }}
                        />
                      </Col>

                      <Col lg={3}>
                        <div
                          className="d-flex justify-content-start align-items-center form-check me-3 mt-1 pl-2"
                        >
                          <input
                            className="form-check-input me-2"
                            type="checkbox"
                            name="is-over-night"
                            id={"is-over-night"}
                            checked={formik?.values?.isOvernight}
                            style={{ minWidth: "16px" }}
                            onChange={(event) => {
                              const isChecked = event.target.checked;
                              formik.setFieldValue(
                                `isOvernight`,
                                isChecked
                              );
                            }}
                          />
                          <label
                            className="form-check-label position-relative"
                            htmlFor={"is-over-night"}
                          >
                            {t("Work until next day")}
                          </label>
                        </div>
                      </Col>

                      {formik.touched.workTimeRange && formik.errors.workTimeRange ? (
                        <div className="text-danger mt-2">
                          {formik.errors.workTimeRange}
                        </div>
                      ) : null}
                    </Row>
                  </Col>
                )
              }

              <Col md={6} lg={4}>
                <div className="mb-3">
                  <Label htmlFor="durationWork" className="form-label">
                    {t("Duration Work")} <span className="text-danger">*</span>
                  </Label>
                  <DropdownOptionNew
                    name="status"
                    dataList={LIST_OPTION_DURATION_WORK || []}
                    placeholder={`${t("Duration Work")}...`}
                    className="dropdown-status-rounded"
                    classNamePrefix="name-prefix"
                    initialValue={formik?.values?.durationWork}
                    onChangeSelect={(e: any) =>
                      formik.setFieldValue(
                        "durationWork",
                        e?.value
                      )
                    }
                    isHasOptionAll={false}
                  />
                  {formik.touched.durationWork && formik.errors.durationWork ? (
                    <div className="text-danger mt-2">
                      {formik.errors.durationWork}
                    </div>
                  ) : null}
                </div>
              </Col>
              
              <Col lg={12}>
                <div className="mb-3">
                  <Label htmlFor="salary" className="form-label">
                    {t("Salary")}{" "}
                    <span className="text-danger">*</span>
                  </Label>

                  <div className="d-flex justify-content-start align-items-center">
                    {CON_WORKING_SALARY?.map((item, index) => {
                      return (
                        <div
                          className="d-flex justify-content-start align-items-center form-check me-3"
                          key={index}
                          onClick={() => {
                            formik?.setFieldValue("salaryNegotiable", item.value)
                          }}
                        >
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name="working_salary"
                            id={`working_salary-${String(item?.value)}`}
                            // value={item?.value}
                            checked={item?.value === formik?.values?.salaryNegotiable}
                            style={{ minWidth: "16px" }}
                            onChange={(event) => {
                              formik?.setFieldValue("salaryNegotiable", item.value)
                              console.log(item.value)
                            }}
                          />
                          <label
                            className="form-check-label position-relative"
                            htmlFor={`working_salary-${String(item?.value)}`}
                          >
                            {t(item?.label)}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Col>

              {
                (
                  formik?.values?.salaryNegotiable === false && (
                  <Col
                    lg={12}
                    className="date-picker-wrapper-custom"
                  >
                    <Row className="mb-3 d-flex">
                      <Col md={3} lg={3}>
                        <div className="mb-3">
                          <Label htmlFor="contact_name" className="form-label">
                            {t("Salary Type")} <span className="text-danger">*</span>
                          </Label>
                          <DropdownOptionNew
                            name="salaryType"
                            dataList={LIST_OPTION_SALARY_TYPE || []}
                            placeholder={`${t("Salary Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={formik?.values?.salaryType}
                            onChangeSelect={(e: any) =>
                              formik.setFieldValue(
                                "salaryType",
                                e?.value
                              )
                            }
                            isHasOptionAll={false}
                          />
                          {formik.touched.salaryType && formik.errors.salaryType ? (
                            <div className="text-danger mt-2">
                              {formik.errors.salaryType}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                     
                      <Col md={6} lg={6}>
                        <div className="mb-3">
                          <Label htmlFor="salaryAmount" className="form-label">
                            {t("Amount")}
                            <span className="text-danger"> *</span>
                          </Label>

                          <div className="d-flex mb-2 gap-2 align-items-center">
                            <NumericFormat
                              className="form-control" 
                              value={formik?.values?.salaryAmount} 
                              placeholder={t("Amount")}
                              allowLeadingZeros 
                              thousandSeparator="," 
                              isAllowed={(values) => {
                                const { formattedValue, floatValue } = values;
                                return formattedValue === "" || (floatValue || 0) <= 9999999999;
                              }}
                              onValueChange={(values: any) => {
                                const {floatValue} = values;
                                formik.setFieldValue(
                                  "salaryAmount",
                                  floatValue
                                )
                              }}
                            />
                            
                            {/* <Input
                              name="salaryAmount"
                              type="number"
                              className="form-control"
                              id="salaryAmount"
                              placeholder={t("Amount")}
                              value={formik?.values?.salaryAmount || 0}
                              onChange={(event: any) =>
                                formik.setFieldValue("salaryAmount", event?.target?.value)
                              }
                            /> */}
                            <div>₩</div>
                          </div>

                          {formik.touched.salaryAmount && formik.errors.salaryAmount ? (
                            <div className="text-danger mt-2">
                              {formik.errors.salaryAmount}
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  )
                )
              }
            </Row>
          </div>
    </React.Fragment>
  );
};

export default WorkingConditions;
